module.exports = __webpack_public_path__ + "img/magor.1cfe53b0.svg";